import moment from "moment-mini";
import Utils from "platform/util/Utils";
import {FormikObject} from "typings";
import {CreditCardState} from "core/redux/deposit/DepositReduxState";
import {FieldType} from "enum/FieldType";
import {DEF_CREDIT_CARD_LENGTH} from "core/redux/deposit/DepositReducer";
import Translations from "platform/translation/Translations";
import {TranslationKey} from "enum/TranslationKey";
import {PaymentMethod} from "enum/PaymentMethod";
import {APMClientDetails} from "protocol/request/DepositByAPMRequest";
import {APMConfig, Configuration} from "core/configuration/Configuration";
import Platform from "platform/Platform";
import {FormikErrors} from "formik";

export class DepositUtil {

    private constructor() {}

    public static formatCardExpiration(formik: FormikObject<CreditCardState>): string {
        const expiration: string = formik.values[FieldType.CardExpiration];
        if (Utils.isNotEmpty(expiration)) {
            const parts: string[] = expiration.split("/");
            return `${parts[0] || Translations.text(TranslationKey.mm)}/${parts[1] || Translations.text(TranslationKey.yy)}`;
        }
        return Translations.text(TranslationKey.mmYY);
    }

    public static buildCardMask(maxCardLength: number): RegExp[] {
        const mask: RegExp[] = [];
        const maxLength: number = maxCardLength || DEF_CREDIT_CARD_LENGTH;
        let count: number = 0;
        for (let i = 0; i < maxLength; i++) {
            mask.push(/\d/);
            if (count < 3 && (i + 1) % 4 === 0) {
                count++;
                mask.push(" " as any);
            }
        }
        return mask;
    }

    public static ccExpired(expiration: string): boolean {
        if (Utils.isNotNull(expiration)) {
            const parts: string[] = expiration.split("/");
            const iMonth: number = parseInt(parts[0], 10);
            const iYear: number = parseInt(parts[1], 10);
            const century = new Date().getFullYear().toString().substring(0, 2);
            const expDate: moment.Moment = moment(`${century}${iYear}` + "-" + (iMonth < 10 ? "0" : "") + iMonth, "YYYY-MM");
            const minMonth: number = new Date().getMonth() + 1;
            const minDate: moment.Moment = moment(new Date().getFullYear() + "-" + (minMonth < 10 ? "0" : "") + minMonth, "YYYY-MM");
            return expDate.isSame(minDate) ? false : !expDate.isAfter(minDate);
        }
        return false;
    }

    public static formatCvc = (cvc: string): string => {
        if (cvc) {
            let result: string = cvc;
            while (result.length < 3) {
                result += "•";
            }
            return result;
        }
        return "•••";
    }

    public static CCFlowType(paymentMethod: string | number): string {
        if (paymentMethod) {
            switch (paymentMethod) {
                case PaymentMethod.OtherCreditCard:
                    return "Other";
            }
        }
        return null;
    }

    public static CCIssuer(cardNumber: string): string {
        if (cardNumber) {
            if (cardNumber.startsWith("6")) {
                return "maestro";
            }
        }
        return "unknown";
    }

    public static BuildAPMClientDetails(method: string | number, values: any): APMClientDetails {
        let IdNumber: string;
        const apmConfig: APMConfig = Platform.config<Configuration>().APM[method];
        if (Utils.isArrayNotEmpty(apmConfig?.FormExtraFields)) {
            apmConfig.FormExtraFields.forEach((fType: FieldType) => {
                switch (fType) {
                    case FieldType.IDCard:
                        IdNumber = values[FieldType.IDCard];
                        break;
                }
            });
        }
        return {
            IdNumber
        };
    }

    public static ActivityFormatValidationComment(errors: FormikErrors<any>): string {
        const fields: string[] = [];
        Object.keys(errors).forEach((k: FieldType) => {
            switch (k) {
                case FieldType.Amount:
                    fields.push("Payment Amount");
                    break;
                case FieldType.CardCvv:
                    fields.push("CVV");
                    break;
                case FieldType.CardExpiration:
                    fields.push("Expiration");
                    break;
                case FieldType.CardName:
                    fields.push("Card Name");
                    break;
                case FieldType.CardNumber:
                    fields.push("Card Number");
                    break;
                case FieldType.Currency:
                    fields.push("Currency");
                    break;
                case FieldType.IDCard:
                    fields.push("ID Card / Passport Nr");
                    break;
            }
        });
        return `Invalid Deposit fields: ${fields.join(", ")}`;
    }
}
